
import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Col, Row, Spinner, } from "react-bootstrap";
import { CheckoutForm } from "../componets/CheckoutForm";
import logo from '../pinLogo2.png'
import API from "../utils/API";
import { useParams, useNavigate  } from "react-router-dom";
//my key 
//const PUBLIC_KEY = "pk_test_51KflreJ7AD03kEtjO2DSbadQhMgnsEEP9aAKxpwJbQOFEmJClDcpxJbUh1pexwRUs9Wz8aeWyvMnCA04mnHJcyvu00HqvykI4h"
const PUBLIC_KEY = "pk_test_51RZGyL2edKLzS5e32yZVy7IHNwWbRU40L2XFqof7mdQXQX367XphKUdtdP2juBsjpKu9JmqORFgx2Giv5Si3cGYP00MSnbpTOG";
const stripeTestPromise = loadStripe(PUBLIC_KEY);

const Payment = () => {
    const { id } = useParams();
    const [depositPaid, setDepositPaid] = useState()
    const [contractData, setContractData] = useState([])


    const [isLoading, setIsLoading] = useState(true)
    const [gotData, setGotData] = useState(false)


    // const [formFull, setFormFull] = useState(true);
    // const [errMsg, setErrMsg] = useState();
    const [paySuccess, setPaySuccess] = useState(false);
    const navigate = useNavigate ();
    useEffect(() => {
        retrieveData();
        // console.log(contractData)
        let clickHome = document.getElementById("homePhoto")
        clickHome.addEventListener('click', function () {
            // console.log("going home")
            navigate (`/${id}`);
        })
        if (contractData.Balance === 0) {
            navigate (`/${id}`);
        }
        if (contractData.Status === 'Cancelled') {
            navigate (`/${id}/expired`);
        }

    }, [gotData, paySuccess]);

    async function retrieveData() {

        await API.getContractData(id)
            .then((res) => {
                if (res.messages[0].code == 401) {
                    navigate (`/${id}`);
                }

                console.log(res)
                setContractData({
                    "ContractType": res.response.data[0].fieldData["ContractType"],
                    "Client_Organization": res.response.data[0].fieldData["AccountContacts::Client_Organization"],
                    "AlcoholBEOTotalTax": res.response.data[0].fieldData["Alcohol BEOTotal Tax"],
                    "AlcoholBEOTotal": res.response.data[0].fieldData["AlcoholBEOTotal"],
                    // "Balance": 0.00,
                    "Balance": res.response.data[0].fieldData["Balance"],
                    "BillingAddress": res.response.data[0].fieldData["Billing Address"],
                    "BookingContactEmail": res.response.data[0].fieldData["BookingContactEmail"],
                    "BookingContactFullName": res.response.data[0].fieldData["BookingContactFullName"],
                    "BookingContactPhone": res.response.data[0].fieldData["BookingContactPhone"],
                    "BowlingBEOTotalAll": res.response.data[0].fieldData["Bowling BEOTotal All"],
                    "BowlingBEOTotal": res.response.data[0].fieldData["Bowling BEOTotal"],
                    "BowlingBEOTotalServiceFeeLine": res.response.data[0].fieldData["Bowling BEOTotal ServiceFeeLine"],
                    "BowlingBEOTotalTax": res.response.data[0].fieldData["Bowling BEOTotal Tax"],

                    "Deposit": res.response.data[0].fieldData["Deposit"],
                    "EquipmentBEOTotalAll": res.response.data[0].fieldData["Equipment BEOTotal All"],
                    "EquipmentBEOTotal": res.response.data[0].fieldData["Equipment BEOTotal"],
                    "EquipmentBEOTotalServiceFeeLine": res.response.data[0].fieldData["Equipment BEOTotal ServiceFeeLine"],
                    "EquipmentBEOTotalTax": res.response.data[0].fieldData["Equipment BEOTotal Tax"],
                    "EventContractTextBottomSE": res.response.data[0].fieldData["Event Contract Text Bottom SE"],
                    "EventContractTextTopSE": res.response.data[0].fieldData["Event Contract Text Top SE"],
                    "EventDate": res.response.data[0].fieldData["Event Date"],
                    "EventEndDate": res.response.data[0].fieldData["Event End Date"],
                    "EventTheme": res.response.data[0].fieldData["Event Theme"],
                    "Comments": res.response.data[0].fieldData["Event comments::Comments"],
                    "EventEndTime": res.response.data[0].fieldData["EventEndTime"],
                    "EventStartTime": res.response.data[0].fieldData["EventStartTime"],
                    "FoodBEOTotal": res.response.data[0].fieldData["FoodBEOTotal"],
                    "FoodBEOTotalAll": res.response.data[0].fieldData["FoodBEOTotal All"],
                    "FoodBEOTotalServiceFeeLine": res.response.data[0].fieldData["FoodBEOTotal ServiceFeeLine"],
                    "FoodBEOTotalTax": res.response.data[0].fieldData["FoodBEOTotal Tax"],
                    "FunBEOTotalAll": res.response.data[0].fieldData["Fun BEOTotal All"],
                    "FunBEOTotal": res.response.data[0].fieldData["Fun BEOTotal"],
                    "FunBEOTotalServiceFeeLine": res.response.data[0].fieldData["Fun BEOTotal ServiceFeeLine"],
                    "FunBEOTotalTax": res.response.data[0].fieldData["Fun BEOTotal Tax"],
                    "GuestCount": res.response.data[0].fieldData["Guest Count"],

                    "LaborBEOTotalAll": res.response.data[0].fieldData["Labor BEOTotal All"],
                    "LaborBEOTotal": res.response.data[0].fieldData["Labor BEOTotal"],
                    "LaborBEOTotalServiceFeeLine": res.response.data[0].fieldData["Labor BEOTotal ServiceFeeLine"],
                    "LaborBEOTotalTax": res.response.data[0].fieldData["Labor BEOTotal Tax"],
                    "LineTotal": res.response.data[0].fieldData["Line Total"],
                    "LiquorBEOTotalAll": res.response.data[0].fieldData["Liquor BEOTotal All"],
                    "LiquorBEOTotalServiceFeeLine": res.response.data[0].fieldData["Liquor BEOTotal ServiceFeeLine"],
                    "Location": res.response.data[0].fieldData["Location"],
                    "PartyName": res.response.data[0].fieldData["Party Name"],
                    "RetailBEOTotal": res.response.data[0].fieldData["Retail BEOTotal"],
                    "RetailBEOTotalAll": res.response.data[0].fieldData["Retail BEOTotal All"],
                    "RetailBEOTotalServiceFeeLine": res.response.data[0].fieldData["Retail BEOTotal ServiceFeeLine"],
                    "RetailBEOTotalTax": res.response.data[0].fieldData["Retail BEOTotal Tax"],
                    "RoomBEOTotalAll": res.response.data[0].fieldData["Room BEOTotal All"],
                    "RoomBEOTotal": res.response.data[0].fieldData["Room BEOTotal"],
                    "RoomBEOTotalServiceFeeLine": res.response.data[0].fieldData["Room BEOTotal ServiceFeeLine"],
                    "RoomBEOTotalTax": res.response.data[0].fieldData["Room BEOTotal Tax"],
                    "SalesRep": res.response.data[0].fieldData["SalesRep"],
                    "SalesRep2": res.response.data[0].fieldData["SalesRep 2"],
                    "ServiceFeeTotal": res.response.data[0].fieldData["ServiceFeeTotal"],
                    "SignatureText": res.response.data[0].fieldData["SignatureText"],
                    "Signed": res.response.data[0].fieldData["Signed"],
                    "SiteContactEmail": res.response.data[0].fieldData["SiteContactEmail"],
                    "SiteContactFullName": res.response.data[0].fieldData["SiteContactFullName"],
                    "SiteContactPhone": res.response.data[0].fieldData["SiteContactPhone"],
                    "Status": res.response.data[0].fieldData["Status"],
                    "SubTotalWSF": res.response.data[0].fieldData["SubTotalWSF"],
                    "TaxTotal": res.response.data[0].fieldData["Tax Total"],
                    "TerritoryName": res.response.data[0].fieldData["Territory Name"],
                    "Total": res.response.data[0].fieldData["Total"],
                    "TotalPerGuest": res.response.data[0].fieldData["Total Per Guest"],
                    "emailHash": res.response.data[0].fieldData["emailHash"],
                    "match": res.response.data[0].fieldData["match"],
                    "__PK_BEO_ID": res.response.data[0].fieldData["__PK_BEO_ID"],
                    "eventItems": res.response.data[0].portalData.Event_Items,
                    "eventPayments": res.response.data[0].portalData.EventPayments,
                    "DepositPaid": res.response.data[0].fieldData["DepositPaid"],
                    "recordID": res.response.data[0].fieldData["recordID"]


                });

                setGotData(true)

                return "done"
            })
        depo()
        setIsLoading(false)

    }
    function paid() {
        setPaySuccess(true)
        setGotData(false)
    }
    function depo() {
        console.log(contractData)
        if (contractData.DepositPaid) {
            setDepositPaid(true)
        } else {
            setDepositPaid(false)
        }
    }

    return (<>
        <h1 className="text-light text-center">Payments</h1>
        {isLoading ? (<div className="text-center">
            <h3 className="text-light">Loading...</h3>
            <img src={logo} className="App-logo" alt="logo" />
        </div>) : (<>


            <Row className="text-light text-center g-0">
                {contractData.Balance > 0 ? (<Row className=" text-light justify-content-md-center">

                    <Col xs={12}>  <Elements stripe={stripeTestPromise} >
                        <CheckoutForm props={contractData} paid={() => paid(true)} depositPaid />
                    </Elements></Col>


                </Row>
                ) : (<h2>Your contract is paid in full.</h2>)}
            </Row>
        </>)}
    </>
    );
};

export default Payment;